const types = {
  GET_HOUSING_SINGLE_ITEM_START: "GET_HOUSING_SINGLE_ITEM_START",
  GET_HOUSING_SINGLE_ITEM_SUCCESS: "GET_HOUSING_SINGLE_ITEM_SUCCESS",
  GET_HOUSING_SINGLE_ITEM_ERROR: "GET_HOUSING_SINGLE_ITEM_ERROR",
};
export default types;
